import type React from "react";
import { createUseStyles } from "react-jss";

import { commonStyles } from "@/base/components/Global/Skeleton/commonStyles";

const SKELETON_ITEM_COUNT = 4;

const useStyles = createUseStyles(({ color, spacing, borderRadius }) => ({
  ...commonStyles,
  container: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.xxl,
  },
  sectionTitle: {
    height: 28,
    width: 160,
    background: color.skeletonElementBg,
    borderRadius: 50,
    position: "relative",
    overflow: "hidden",
    marginLeft: spacing.xxl,
    marginTop: spacing.x4l,
    marginBottom: spacing.l,

    "&:after": {
      content: "''",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      position: "absolute",
      backgroundImage: color.skeletonElementShimmer,
      animation: "$shimmer 1.5s infinite",
      overflow: "hidden",
    },
  },
  itemContainer: {
    padding: [spacing.l, spacing.xxl],
    display: "flex",
    gap: spacing.s,
    backgroundColor: color.productRowBg,
    borderRadius: borderRadius.l,
  },
  textContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: spacing.s,
    justifyContent: "center",
    height: 126,
  },
  line: {
    height: 14,
    background: color.skeletonElementBg,
    borderRadius: 50,
    position: "relative",
    overflow: "hidden",

    "&:after": {
      content: "''",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      position: "absolute",
      backgroundImage: color.skeletonElementShimmer,
      animation: "$shimmer 1.5s infinite",
      overflow: "hidden",
    },
  },
  titleLine: {
    width: "70%",
  },
  descriptionLine: {
    width: "90%",
    height: 10,
  },
  priceLine: {
    width: "30%",
    marginTop: spacing.s,
  },
  circle: {
    width: 126,
    minWidth: 126,
    height: 126,
    borderRadius: "50%",
    background: color.skeletonElementBg,
    position: "relative",
    overflow: "hidden",

    "&:after": {
      content: "''",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      position: "absolute",
      backgroundImage: color.skeletonElementShimmer,
      animation: "$shimmer 1.5s infinite",
      overflow: "hidden",
    },
  },
}));

const ProductListSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.sectionTitle} />
      <div className={classes.container}>
        {Array.from({ length: SKELETON_ITEM_COUNT }).map((_, idx) => (
          <div key={idx} className={classes.itemContainer}>
            <div className={classes.textContainer}>
              <div className={`${classes.line} ${classes.titleLine}`} />
              <div className={`${classes.line} ${classes.descriptionLine}`} />
              <div className={`${classes.line} ${classes.priceLine}`} />
            </div>
            <div className={classes.circle} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductListSkeleton;
